import { readFromFile } from "../shared.js";

// encapsulate Configuration of chat within an object
export let ChatConfig = {
  customerConfigFile: "gobot1aCustomer.js", // selects which customer's config info to use, which allows this code base to support multiple customers.  Relative to the config directory
  systemPromptFile: "defaultCustomer/prompt.txt", // file containing the system prompt, relative to the config directory.   This will be overwritten by the customerConfig if it specifies a different file
  personalize: "", // user personalization added to company profile
  cid: "", // chat id
  uid: "", // user id
  temperature:0.0, //chat temperature [0-2] Temperature (higly creative = 1, boring = 0) to use when we ask ChatGPT to generate text
  score:0.79, // expertise threshold [0-1] Only retrieve expertise with match score above this threshold
  autobot:false, // autonomous User mode
  VENDOR_SLACK_TRACE: false,
  logs: false, // log chats to slack .  TODO this seems to log even with false? Check this
  autobotPrompt: "", // autobot prompt
  autobotMessages: [],
  systemPrompt:"",
  COMPLETION_URL: "https://api.openai.com/v1/chat/completions",
  QUANTELLIA_OPENAI_TOKEN: "sk-proj-x6AM4ThdgPph2p7V1osoT3BlbkFJ1LcAJ3s9zqLuZ4X786ql", // TODO SECURITY HOLE: need to move to server to protect this
  KBLOOKUP: false, // TODO move this to a feature, maybe called "rag"?
  SUMMARIZATION: false, // TODO move this to a feature, maybe called "summarization"
  TESTINGSKIPLLMINVOCATION: false, 
  streamingMode: true, // We need a non-streaming mode for when chatGPT is sending us JSON or code (which we don't display, let alone stream)
  KBTRACKING: true,   // set to true if you'd like more detailed KB tracking in Slack
};


export async function loadCustomerConfig() {
  const customerConfigFile = ChatConfig.customerConfigFile || "defaultCustomer.js"; // Fallback to default
  try {
    const customerModule = await import(`../../config/${customerConfigFile}`);
    // Access the actual export (customerConfig) from the module
    const customerConfig = customerModule.customerConfig;

    if (customerConfig) {
      Object.assign(ChatConfig, customerConfig); // Merge customer-specific config into ChatConfig
      console.log(`Customer configuration loaded from: ${customerConfigFile}`);
    } else {
      console.error(`No customerConfig export found in module: ${customerConfigFile}`);
    }

    return ChatConfig;
  } catch (error) {
    console.error(`Failed to load configuration for customer with config file: ${customerConfigFile}`, error);
  }
}

async function initializeChatConfig() { 
console.log("Just created firrst version of ChatConfig");
// Load the customer-specific config and use it to override the contents
// of ChatConfig: the default config.

////////////////////////////
// Load all config parameters, including those that are specific to a particular
// customer.  Do it in this order:
// 1. Default ChatConfig is already defined
// 2. Load the customer-specific config and merge it into ChatConfig
// 3. Load the system prompt and merge it into ChatConfig
// (async () => {
  console.log("About to execute loadCustomerConfig");
  ChatConfig = await loadCustomerConfig();
  console.log(`ChatConfig loaded and customized for customer: ${ChatConfig.customerConfigFile}`);
  window.ChatConfig = ChatConfig; // make it global for debugging. TODO remove this

// Load the system prompt into the ChatConfig, using the file specified in systemPromptFile
if (!ChatConfig.systemPromptFile) {
  console.error("No systemPromptFile specified in customerConfig");
  ChatConfig.systemPrompt = "Please be a kind bot";
}
else try {
  // const systemPromptFile = `../../config/${ChatConfig.systemPromptFile}`;
  const systemPromptFile = `./config/${ChatConfig.systemPromptFile}`; // Note that chatconfig.js ends up in bundle.js, which sits at the top of the dist folder, which contains config
  console.log(`About to read system prompt from: ${systemPromptFile}`);

  const promptFromFile = await readFromFile(systemPromptFile);

  if (promptFromFile) {
    ChatConfig.systemPrompt = promptFromFile; // Merge systemPrompt into ChatConfig
    console.log(`System prompt loaded from: ${systemPromptFile}`);
  } else {
    console.error(`No systemPrompt export found in module: ${systemPromptFile}`);
  }
} catch (error) {
  console.error(`Failed to load system prompt with file: ${systemPromptFile}`, error);
}
// })();
}

// Export a promise that the calling function can wait on to ensure that all is complete
export const chatConfigInitializationPromise = await initializeChatConfig();